import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, UrlSegment } from '@angular/router';
import { Observable, of, empty } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
//import { } from '@app/constants';
import { DataService, NavigationService, PagesService, StoreService } from '@app/data';

@Injectable()
export class PageResolver implements Resolve<boolean> {

   constructor(
      private data: DataService,
      private navigation: NavigationService,
      private pages: PagesService,
      private store: StoreService
   ) { }

   resolve(
      next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
   ): Observable<boolean> {

      const last = this.data.getLastRoute();

      //console.log('======== >>>>>> PageResolver next', next);
      //console.log('======== >>>>>> PageResolver JSON.stringify(next.queryParams)', JSON.stringify(next.queryParams));
      //console.log('======== >>>>>> PageResolver next.parent', next.parent);
      //console.log('======== >>>>>> PageResolver last', last);

      /* QUERY PARAMS */

      const queryParams = JSON.parse(JSON.stringify(next.queryParams));

      /* URL */

      //console.log('PageResolver next.pathFromRoot', next.pathFromRoot);

      const path = this.getResolvedPath(next).slice(0,-1);
      const url = this.getResolvedUrl(next)/*.replace('//', '')*/;
      const parentPathSchool = url.split('/').slice(0,-1);
      const parentPageUrl = (queryParams.sekce && !next.params.school) ? queryParams.sekce[0] : next.params.school ? parentPathSchool.join('/') : url;

      //console.log('======== >>>>>> PageResolver path', path);
      //console.log('======== >>>>>> PageResolver url', url);
      //console.log('======== >>>>>> PageResolver parentPathSchool', parentPathSchool);
      //console.log('======== >>>>>> PageResolver parentPageUrl', parentPageUrl);
      

      /* PAGE NAME */

      let pageName: string;

      if (next.data.virtualParent || next.data.virtualGrandParent || next.data.simplePage) {
         pageName = url;
      }
      else if (queryParams.sekce && queryParams.sekce.indexOf('/hledat') >= 0) {
         pageName = '/hledat';
      }
      else {
         pageName = queryParams.sekce instanceof Array ? queryParams.sekce[0] : queryParams.sekce;
      }

      console.log('======== >>>>>> PageResolver pageName', pageName);


      /* SECTION */

      const section = pageName ? pageName.split('/')[1] : '';
 
      /* SUBPAGE */

      const subPage = queryParams.podstranka;
      
      /* NAVIGATION + BACK BUTTON */

      const showBackBtn = (next.data.detail || next.params.school || subPage) ? true : false;
      const hideNav = next.data.subPage || subPage || showBackBtn;

      if (next.data.section !== 'navigation') {
         this.navigation.setShowBackButton(showBackBtn);
         this.navigation.setHideNav(hideNav);
         this.navigation.setNavigationOpen(false);
      }
      else {
         this.navigation.setShowBackButton(false);
         this.navigation.setHideNav(true);
         this.navigation.setNavigationOpen(true);
      }

      /* ANIMATION PARAMS */

      const detailToDetail: boolean = next.data.detail && last.data && last.data.detail;
      const toParent: boolean = (pageName === last.pageName && next.data.virtualParent && last.data && last.data.detail) ? true : false;
      let lastScrollPosition = 0;

      if (toParent && this.store.hasStore(pageName)) {
         lastScrollPosition = this.store.getExistingStore(pageName).getLastScrollPosition();
      }

      //console.log('======== >>>>>> PageResolver toParent', toParent);
      //console.log('======== >>>>>> PageResolver lastScrollPosition', lastScrollPosition);

      this.data.setRouteAnimationParams$({value: next.data.index, params: {y: - lastScrollPosition + 'px', animationDuration: '0.8s'} });

      /* CACHE ID */

      let noPageQueryParams = {...queryParams};

      if (noPageQueryParams.strana) {
         delete noPageQueryParams.strana;
      }

      if (noPageQueryParams.sekce) {
         //console.log('PageResolver noPageQueryParams.sekce', noPageQueryParams.sekce);

         if (noPageQueryParams.sekce instanceof Array) {

            const indexOfStore = noPageQueryParams.sekce.indexOf(pageName);
            //console.log('PageResolver indexOfStore', indexOfStore);

            if (indexOfStore >= 0) {
               noPageQueryParams.sekce.splice(indexOfStore, 1);
            }
            
            if (noPageQueryParams.sekce.length === 0) {
               delete noPageQueryParams.sekce;
            }
         }
         else if (noPageQueryParams.sekce === pageName) {
            delete noPageQueryParams.sekce;
         }
      }

      const cacheId = pageName + '-' + JSON.stringify(noPageQueryParams);

      /* FULLTEXT */

      const fullText = queryParams.text ? queryParams.text : '';

      /* SCROLL IN TO VIEW */

      // between details
      if (detailToDetail) {         
         this.data.setScrollIntoView('top');
      }

      if (pageName === last.pageName && !next.data.detail && (last.data && !last.data.detail)) {
         this.data.setScrollIntoView(pageName);
      }

      /* PAGE */

      const page = {
         pageName,
         url,
         params: next.params,
         data: next.data,
         queryParams,
         offsetY: lastScrollPosition,
         parentPageUrl,
         section,
         subPage,
         cacheId
      };

      console.log('======== >>>>>> PageResolver page', page);

      if (next.data && next.data.section !== 'navigation') {
         this.data.setLastRoute(page); 
         this.pages.setCurrentRoute(page);
      }

      return of(true);
   }

   private getResolvedUrl = (route: ActivatedRouteSnapshot): string => route.pathFromRoot
     .map(route => route.url.map(segment => segment.toString()).join('/'))
     .join('/');

   private getResolvedPath = (route: ActivatedRouteSnapshot): string[][] => route.pathFromRoot
     .map(route => route.url.map(segment => segment.toString()));
}

